var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPackageGcadviceMedium = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 62,
    viewBox: "0 0 135 62",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h135v62H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.214 2.067)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.571 57.008c0 .397-7.324.859-15.764.859s-15.281-.322-15.281-.72c0-.396 6.841-.718 15.281-.718 8.44 0 15.764.183 15.764.58z",
    fill: "#32323F",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.179.001c8.732.018 15.787 12.77 15.756 28.48-.03 15.712-4.76 28.469-16.644 28.469C8.3 56.95.283 44.129.314 28.417.344 12.707 7.447-.016 16.179.001z",
    fill: "#7D1300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.342 28.477c-.03 15.711-6.622 28.434-14.725 28.419l-.13-.001a7.641 7.641 0 0 1-1.58-.194 8.874 8.874 0 0 1-2.543-1.028 8.484 8.484 0 0 1-.286-.176C4.205 51.777-.024 41.057 0 28.42.03 12.707 6.623-.016 14.725 0c.233 0 .464.011.693.033 7.779.719 13.951 13.184 13.922 28.444h.002z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 13.93 28.449)",
    cx: 13.931,
    cy: 28.449,
    rx: 25.142,
    ry: 12.967
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-89.89 13.3 28.448)",
    cx: 13.299,
    cy: 28.448,
    rx: 20.467,
    ry: 10.555
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 12.518 28.445)",
    cx: 12.518,
    cy: 28.445,
    rx: 16.602,
    ry: 8.563
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#FFF",
    transform: "rotate(-89.89 11.998 28.445)",
    cx: 11.998,
    cy: 28.445,
    rx: 11.116,
    ry: 5.733
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#CD2B31",
    transform: "rotate(-89.89 11.998 28.445)",
    cx: 11.998,
    cy: 28.445,
    rx: 5.601,
    ry: 2.889
  })), /*#__PURE__*/React.createElement("path", {
    d: "M17.877 26.41c-.321.784.659 1.622.029 3.252-.63 1.63 1.808-2.088 1.808-2.088l-.703-1.837-1.135.674h.001z",
    fill: "#CD2B31"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 18.833,
    cy: 28.551,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.025 28.98s.619-.15.616-.328c-.003-.146-.629-.23-.629-.23l-3.441.252.012.558 3.442-.252z",
    fill: "#E7E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.807 28.465c-.088-.283-.334-.482-.616-.472l-4.231.158.015.34.047 1.08 4.232-.156c.342-.012.604-.33.587-.71l-.002-.049a.812.812 0 0 0-.033-.192z",
    fill: "#E7E7E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.96 28.152-4.312.335c-.107.004-.863.059-1.69.152-1.09.123-2.304.31-2.303.533v.002c.033.391 3.792.396 4.04.385l4.327.014-.047-1.08-.015-.34v-.001z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.828 29.055-4.406.165c-.013.017-.024.035-.036.053l-.018.028a1.763 1.763 0 0 0-.199.458c-.172.62-.019 1.33.444 1.804.32.328.727.482 1.126.467.4-.014.79-.199 1.082-.549l1.435-1.735.164-.198.408-.493z",
    fill: "#1B7690"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.807 28.465c-.088-.283-.334-.482-.616-.472l-4.231.158-4.312.336c-.107.004-.863.059-1.69.152l-.083.213 6.1-.36 1.348-.08s2.756-.072 3.483.052z",
    fill: "#1F1F39",
    opacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.486 26.32c.4-.014.806.14 1.126.467l2.215 2.268-4.407.165c-.55-.663-.565-1.686-.016-2.35a1.47 1.47 0 0 1 1.082-.55z",
    fill: "#106275"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42 29.732a137.266 137.266 0 0 1-4.034-.46c-.005.016-.012.032-.018.047a4.158 4.158 0 0 0-.199.764c.514-.156 1.09-.133 1.843-.105.764.03 1.88.026 2.244.084l.164-.33z",
    fill: "#1F1F39",
    opacity: 0.18
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPackageGcadviceMedium);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/package-gcadvice-medium.e56269c823e1d17d2fafd30833b6782b.svg";